// Which filing button the fax viewer shows this user (faxtable.jsx), from the
// practice's fax profile (config/practice.js FAX_PROFILES sendToEmr) and the
// user's Tasks privileges (state.userPrivileges.taskrpm, App.js). One filing
// button per user (10-08), except in "privilege" mode (owner 10-16: both):
//   sendToEmr true       Send to EMR for everyone (care timeline copy + review
//                        task; its "Send to Athena" box needs "send to athena")
//   sendToEmr false      Send to Athena only, with "send to athena" (7825)
//   sendToEmr "privilege"  (9928, owner 10-16) Send to EMR for users with
//                        "send to emr" (its box as above) and the Send to
//                        Athena button for users with "send to athena"; a user
//                        with both sees both buttons (Send to EMR for the care
//                        timeline copy + review task, Send to Athena for page
//                        groups). A
//                        user with neither sees which permissions filing needs
//                        (this mode only; the other modes show no hint, as
//                        before).
//   unset (no profile)   as true, as before 10-16
//   anything else        (a typo such as "Privilege") as "privilege": Send to
//                        EMR never opens to everyone by mistake

export const PRIV_SEND_TO_ATHENA = "send to athena"; // Tasks privilege (9928 id 54)
export const PRIV_SEND_TO_EMR = "send to emr"; // Tasks privilege (9928 id 55)

export const FILING_HINT_BOTH = "Filing needs the Send to Athena or Send to EMR permission — ask an admin";

/**
 * @param {object|null} profile        practiceFaxProfile()
 * @param {string[]|null} taskPrivileges  the user's Tasks privilege names
 * @returns {{canSendToAthena: boolean, canSendToEmr: boolean, showEmr: boolean,
 *            showAthenaButton: boolean, hint: string}}
 */
export function faxFilingAccess(profile, taskPrivileges) {
  const privs = Array.isArray(taskPrivileges) ? taskPrivileges : [];
  const mode = profile ? profile.sendToEmr : undefined;
  const canSendToAthena = privs.includes(PRIV_SEND_TO_ATHENA);
  const everyone = mode === true || mode === undefined; // as before 10-16
  const byPrivilege = !everyone && mode !== false; // "privilege" or unrecognised
  const canSendToEmr = everyone || (byPrivilege && privs.includes(PRIV_SEND_TO_EMR));
  const showEmr = canSendToEmr;
  const showAthenaButton = byPrivilege ? canSendToAthena : !showEmr && canSendToAthena;
  const hint = !showEmr && !showAthenaButton && byPrivilege ? FILING_HINT_BOTH : "";
  return { canSendToAthena, canSendToEmr, showEmr, showAthenaButton, hint };
}
